<script setup lang="ts">

</script>

<template>
    <a :href="$route('logout.logout')"
       class="text-gray-500 dark:text-gray-400
               bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-4
               focus:ring-red-200 dark:focus:ring-red-700 rounded-lg
               p-2.5">
        <svg class="w-7 h-7 text-gray-800 dark:text-white"
             aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
             viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 18V6h-5v12h5Zm0 0h2M4 18h2.5m3.5-5.5V12M6 6l7-2v16l-7-2V6Z"/>
        </svg>
    </a>
</template>

<style scoped>

</style>
